import { Box, Button, Modal, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { modalAlertStyle } from "../../styles/common/modal-alert";
import { Cancel } from "@mui/icons-material";

export default function ModalAlert({
  variant = "success",
  open,
  message,
  title,
  buttonTitle,
  onOk,
  onClose,
}: {
  variant?: string;
  open: boolean;
  message?: string;
  title?: string;
  buttonTitle?: string;
  onOk?: () => void;
  onClose?: () => void;
}) {
  const [isOpen, setIsOpen] = useState(open);

  const content = {
    success: {
      title: "Success",
      icon: "/assets/alert/ilustrasi-cody-success.png",
    },
    failed: {
      title: "Failed",
      icon: "/assets/alert/ilustrasi-cody-failed.png",
    },
    info: { title: "Info", icon: "/assets/alert/ilustrasi-cody-alert.png" },
  };

  const handleClose = (_, reason) => {
    if (reason === "backdropClick") return;
    onClose?.();
    setIsOpen(false);
  };

  const handleOk = () => {
    onOk?.();
    handleClose(null, "okClick");
  };

  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      sx={modalAlertStyle.modalAlert}
      disableEnforceFocus
    >
      <Box className="flex flex-col bg-white border-2 p-5 rounded-lg">
        {/* <Box component="img" src={content[variant].icon} sx={modalAlertStyle.modalAlertLogo} /> */}
        <Box className="flex w-full h-32 items-center justify-center">
          {variant == "failed" && <Cancel color="error" className="text-9xl" />}
        </Box>
        <Stack sx={modalAlertStyle.modalAlertContent}>
          <Typography sx={modalAlertStyle.modalAlertTitle}>
            {title ? `${title}` : content[variant].title}
          </Typography>
          <Typography sx={modalAlertStyle.modalAlertDesc}>{message}</Typography>
        </Stack>
        <Button
          variant="contained"
          color="primary"
          sx={modalAlertStyle.modalAlertButton}
          onClick={handleOk}
        >
          {buttonTitle || "Ok"}
        </Button>
      </Box>
    </Modal>
  );
}
